import { render, staticRenderFns } from "./GetStartedView.vue?vue&type=template&id=6fa4ee21"
import script from "./GetStartedView.vue?vue&type=script&lang=ts"
export * from "./GetStartedView.vue?vue&type=script&lang=ts"
import style0 from "./GetStartedView.vue?vue&type=style&index=0&id=6fa4ee21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports